export type PageTargetType = 'lead' | 'ad_campaign';

type PageIdentitySource = {
  lead?: { company?: { name?: string | null } | null } | null;
  adCampaign?: { name?: string | null } | null;
  targetType?: PageTargetType | null;
  staticUrl?: string | null;
};

/**
 * The display identity of a page variant: lead pages are named by their
 * company, ad pages by their ads campaign (Google Ads / LinkedIn Ads). Structural input so both
 * ReadPage and EmbeddedPage callers fit; falls back to the static URL (the
 * manager-page precedent) and then '-'. Never assume `lead.company` exists —
 * it is null on every ad page.
 */
export function getPageDisplayIdentity(page: PageIdentitySource): {
  label: string;
  targetType: PageTargetType;
} {
  const targetType: PageTargetType =
    page.targetType ?? (page.adCampaign ? 'ad_campaign' : 'lead');
  const label =
    page.lead?.company?.name ??
    page.adCampaign?.name ??
    page.staticUrl ??
    '-';
  return { label, targetType };
}
